import { ReactNode } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { ExclamationOctagonIcon } from '@la/ds-ui-components';
import { Alert } from '../Alert/Alert';
import {
  StepperDrawer,
  StepperDrawerProps,
} from '../StepperDrawer/StepperDrawer';
import styles from './Stepper.module.scss';
import StepperBars from './StepperBars';

export type StepperProps = StepperDrawerProps & {
  addToCart?: boolean;
  children: ReactNode;
  currentStep: { longDesc: string; shortDesc: string };
  error: boolean;
  errorMessage?: string;
  onCancelButtonClick?: () => void;
  showBackButton?: boolean;
  showDrawer: boolean;
  showSteps: boolean;
};

const STEP_ERROR_MESSAGE = 'Please fix the errors below before continuing.';

export const Stepper = ({
  addToCart,
  children,
  currentNextAction,
  currentStep,
  error,
  errorMessage,
  form,
  handleNextClick,
  numberOfTotalSteps,
  onBackClick,
  showBackButton = false,
  showDrawer,
  showSteps,
  stepNumber,
  type,
  onCancelButtonClick,
}: StepperProps) => {
  const { showUpdatedECommerceInRegFlowContent } = useFlags();

  const longDesc = currentStep?.longDesc ?? 'success';
  const stepContainerLabel = showUpdatedECommerceInRegFlowContent
    ? longDesc
    : `Step ${stepNumber} of ${numberOfTotalSteps}: ${longDesc}`;
  return (
    <div className={styles.stepperContent}>
      {showSteps ? (
        <div className={styles.stepContainer}>
          {showUpdatedECommerceInRegFlowContent ? <StepperBars /> : null}
          <h3 className={styles.stepContainerLabel}>{stepContainerLabel}</h3>
        </div>
      ) : null}

      {error ? (
        <Alert
          icon={<ExclamationOctagonIcon size="xl" fill="var(--red)" />}
          message={errorMessage || STEP_ERROR_MESSAGE}
        />
      ) : null}

      {children}

      {showDrawer ? (
        <StepperDrawer
          addToCart={addToCart}
          currentNextAction={currentNextAction}
          form={form}
          handleNextClick={handleNextClick}
          numberOfTotalSteps={numberOfTotalSteps}
          onBackClick={onBackClick}
          onCancelButtonClick={onCancelButtonClick}
          showBackButton={showBackButton}
          stepNumber={stepNumber}
          type={type}
        />
      ) : null}
    </div>
  );
};
